import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { ButtonGroup, CardActionArea, CardActions, CardContent, DialogActions, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { addRequestToRentService } from './request-rent-service';
import { db } from '../../../firebase';
import { showErrorSnackbar, showWarningSnackbar } from '../../shared/snackbar/snackbar-slice';
import { useNavigate } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import dayjs, { Dayjs } from 'dayjs';
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  tableHeader: {
    background: "#111111",
    height: "100%",
    color: "#fbbbd3",
    fontSize: 14,
  },
  button: {
      background: "#111111",
      color: "#fbbbd3",
      '&:hover': {
          backgroundColor: '#fbbbd3',
          color: '#111111',
      },
  },
  buttonText: {
      color: "#111111",
      '&:hover': {
          backgroundColor: '#fbbbd3',
          color: '#111111',
      },
  },
  text: {
      color: "#111111",
  },
  title: {
      background:"#111111",
  },
}));

const initiaFormData = {
    fullName: "",
    address: "",
    phoneNumber: "",
    facebookLink: "",
    pickupDate: null,
    returnDate: null,
    extendReturnDate: null,
};

function RequestRentForm() {
  const classes = useStyles();
  const [formData, setFormData ] = useState(initiaFormData);
  const [datePickup, setDatePickup] = useState(null);
  const [dateReturn, setDateReturn] = useState(null);
  const [dateExtendReturn, setDateExtendReturn] = useState(null);
  const items = useSelector((state) => state.requestRentSlice.rows);
  const isLoading = useSelector((state) => state.requestRentSlice.isLoading);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (items.length === 0) {
      navigate('/');
      dispatch(showWarningSnackbar("You do not have items to rent."));
    }
  }, [items]);

  
  // handle input
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
};

// handle pick up date
const handlePickupDateChange = (newValue) => {
  if (newValue) {
    setDatePickup(moment(newValue).startOf('day'));
    
    // Automatically set the return date to the third day from the pick-up date
    let returnDate = moment(newValue).add(2, 'days').startOf('day');
    // If the return date falls on Saturday or Sunday, move it to Monday
    if (returnDate.isoWeekday() === 6) { // Saturday
      returnDate = moment(newValue).add(4, 'days').startOf('day');
    } else if (returnDate.isoWeekday() === 7) { // Sunday
      returnDate = moment(newValue).add(3, 'days').startOf('day');
    }
    setDateReturn(returnDate);
    setDateExtendReturn(null);
  }
};

// handle return date
// const handleReturnDateChange = (newValue) => {
//   if (newValue) {
//     setDateReturn(moment(newValue).startOf('day'));
//   }
// };

// handle extend return date
const handleExtendReturnDateChange = (newValue) => {
  if (newValue) {
    const selectedDate = moment(newValue).startOf('day');

    // Disable the same date as the return date
    if (dateReturn && selectedDate.isSame(dateReturn, 'day')) {
      return true;
    }

    setDateExtendReturn(selectedDate);
  }
};

// handle request submit
const handleRequestSubmit = async (e) => {
    e.preventDefault();  
   
    try {
        const totalAmountToPay = items.reduce((total, row) => {
          return total + (parseFloat(row.rent_price) + parseFloat(row.deposit));
        }, 0);

        const new_data = {
          ...formData,
          items_to_rent: items,
          total_amount_to_pay: totalAmountToPay,
          pickupDate: datePickup,
          returnDate: dateReturn,
          extendReturnDate: dateExtendReturn,
        }
        await addRequestToRentService(dispatch, db, "rent_requests", new_data);
        navigate('/');
      } catch (e) {
        dispatch(showErrorSnackbar("Something went wrong while trying to submit request."));
        console.error("RequestRentForm handleRequestSubmit error: ", e);
      }
};

  return (
    <>
      <Card
        variant="outlined"
        style={{
            marginTop: '5vh',
            padding: '5vh',
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
          <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        id="filled-basic"
                        label="Full Name"
                        variant="filled"
                        fullWidth
                        name="fullName"
                        onChange={handleInputChange}
                        required
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="filled-basic"
                        label="Address"
                        variant="filled"
                        fullWidth
                        name="address"
                        onChange={handleInputChange}
                        required
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="filled-basic"
                        label="Phone #"
                        variant="filled"
                        fullWidth
                        name="phoneNumber"
                        onChange={handleInputChange}
                        required
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="filled-basic"
                        label="Facebook Link"
                        variant="filled"
                        fullWidth
                        name="facebookLink"
                        onChange={handleInputChange}
                    />
                </Grid>
                <Grid item xs={6}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      disablePast
                      shouldDisableDate={(date) => {
                        const selectedDate = moment(date).startOf('day');
                        const today = moment().startOf('day');
                        const tomorrow = moment().add(1, 'day').startOf('day');
                  
                        // Disable today, tomorrow, and weekends (Saturday and Sunday)
                        return selectedDate.isSameOrBefore(today) || selectedDate.isSameOrBefore(tomorrow) || selectedDate.isoWeekday() > 5;
                      }}
                      variant="filled"
                      label="Pick-up Date"
                      openTo="year"
                      views={["year", "month", "day"]}
                      fullWidth
                      name="pickupDate"
                      // value={datePickup}
                      onChange={handlePickupDateChange}
                      required
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={6}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      disablePast
                      shouldDisableDate={(date) => {
                        const selectedDate = moment(date).startOf('day');
                        const today = moment().startOf('day');
                        const tomorrow = moment().add(1, 'day').startOf('day');
                  
                        // Disable today, tomorrow, and weekends (Saturday and Sunday)
                        return selectedDate.isSameOrBefore(today) || selectedDate.isSameOrBefore(tomorrow) || selectedDate.isoWeekday() > 5;
                      }}
                      variant="filled"
                      label="Return Date"
                      openTo="year"
                      views={["year", "month", "day"]}
                      fullWidth
                      name="returnDate"
                      value={dateReturn}
                      // onChange={handleReturnDateChange}
                      required
                      readOnly
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                    {`Do you wish to extend your rent days? Then, please select your preferred return date below.`}
                  </Typography>
                  <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                    {`Note: There will be an additional extension fee payment of 50 PHP for each wig and 100 PHP for each costume/set per day. Once you submit your rental request, you will receive the updated total amount to pay via SMS or Facebook Messenger.`}
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      disablePast
                      shouldDisableDate={(date) => {
                        const selectedDate = moment(date).startOf('day');
                        const today = moment().startOf('day');
                        const tomorrow = moment().add(1, 'day').startOf('day');
          
                        // Disable today, tomorrow, and weekends (Saturday and Sunday)
                        return (
                          selectedDate.isSameOrBefore(today) ||
                          selectedDate.isSameOrBefore(tomorrow) ||
                          selectedDate.isoWeekday() > 5 ||
                          dateReturn && selectedDate.isSameOrBefore(dateReturn, 'day')
                        );
                      }}
                      variant="filled"
                      label="Extend Return Date"
                      openTo="year"
                      views={["year", "month", "day"]}
                      fullWidth
                      name="extendReturnDate"
                      value={dateExtendReturn}
                      onChange={handleExtendReturnDateChange}
                      disabled={!dateReturn}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                    {`Note: Please wait for the confirmation through SMS or Facebook Messenger after submitting your request. (Typically, within 24 hours.)`}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  
                </Grid>
              </Grid>
            </CardContent>
              <DialogActions>
                <Button
                  variant="text"
                  // onClick={handleRequestSubmit}
                  // color="primary"
                  className={classes.buttonText}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  onClick={handleRequestSubmit}
                  // color="primary"
                  className={classes.button}
                  disabled={!(formData.fullName && formData.address && formData.phoneNumber && datePickup) || isLoading}
                >
                  {
                      isLoading ? (
                          "Submitting..."
                      ) : (
                          "Submit Request"
                      )
                  }
                </Button>
              </DialogActions>
          </Grid>
        </Grid>
      </Card>
    </>
  )
}

export default RequestRentForm;
